import { render, staticRenderFns } from "./CompetitorFinancials.vue?vue&type=template&id=677f78d2&scoped=true&"
import script from "./CompetitorFinancials.vue?vue&type=script&lang=js&"
export * from "./CompetitorFinancials.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorFinancials.vue?vue&type=style&index=0&id=677f78d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f78d2",
  null
  
)

export default component.exports